export default __webpack_public_path__ + "static/media/NationalWeb-Light.5bb9bdad.eot";